import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'src/app/features/auth/services/auth.service';
import { LocalStorageService } from 'src/app/shared/localstorage.service';

export const loggedInAuthGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.getAuthStatus()) {
    try {
      router.navigate([LocalStorageService.get('currentUrl') || '/catalogs']);
      return false;
    } catch (e) {
      router.navigate(['/catalogs']);
      return false;
    }
  }
  return true;
};
